import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Tab, Tabs, IconButton, Tooltip } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import CodeEditor from '@uiw/react-textarea-code-editor';



function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TablaTipoComprobante({ Factura, NombreFactura, Boleta,NombreBoleta, NotaCredito,NombreNotaCredito, NotaDebito,NombreNotaDebito, id="" }) {
  const [value, setValue] = React.useState(0);
  const [cFactura, setCFactura] = useState(Factura);
  const [ccs, setCcs] = useState(Boleta);
  const [cjava, setCjava] = useState(NotaCredito);
  const [cphp, setCphp] = useState(NotaDebito);
  const [copyText, setCopyText] = useState('copy');
  const [copyCode, setCopyCode] = useState(Factura);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCopyText('copy');
    switch (newValue) {
      case 0:
        setCopyCode(cFactura);
        break;
      case 1:
        setCopyCode(ccs);
        break;
      case 2:
        setCopyCode(cjava);
        break;
      case 3:
        setCopyCode(cphp);
        break;
      default:
        setCopyCode(cFactura);
    }
  };

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(copyCode);
    setCopyText('copied!')
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label={NombreFactura} {...a11yProps(0)} />
          <Tab label={NombreBoleta} {...a11yProps(1)} />
          <Tab label={NombreNotaCredito} {...a11yProps(2)} />
          <Tab label={NombreNotaDebito} {...a11yProps(3)} />
        </Tabs>
        {/*
        <Box>
          <Tooltip title={copyText}>
            <IconButton aria-label='copy' color='secondary' size="small" onClick={handleCopyClick}>
              <ContentCopy fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
        */}
        
      </Box>
      <TabPanel value={value} index={0}id={id}>
        <CodeEditor
          //Factura
          value={cFactura}
          data-color-mode="dark"
          language="js"
          placeholder="Please enter Factura code."
          onChange={(evn) => setCFactura(evn.target.value)}
          padding={15}
          style={{
            fontSize: 14,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={1} id={id}>
        <CodeEditor
          //C# RESTSHAR´P
          value={ccs}
          data-color-mode="dark"
          language="js"
          placeholder="Please enter C# code."
          onChange={(evn) => setCcs(evn.target.value)}
          padding={15}
          style={{
            fontSize: 14,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={2} id={id}>
        <CodeEditor
          //JAVA OKHTTP
          value={cjava}
          data-color-mode="dark"
          language="js"
          placeholder="Please enter JAVA code."
          onChange={(evn) => setCjava(evn.target.value)}
          padding={15}
          style={{
            fontSize: 14,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={3} id={id}>
        <CodeEditor
          // PHP REQUEST
          value={cphp}
          data-color-mode="dark"
          language="js"
          placeholder="Please enter PHP code."
          onChange={(evn) => setCphp(evn.target.value)}
          padding={15}
          style={{
            fontSize: 14,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      
    </Box>
  );
}